import { useTranslation } from 'react-i18next';

function TabList() {
  const { t } = useTranslation();

  const tabBOProcess = [
    {
      id: 1,
      name: t('biz_process.main_information'),
    },
    {
      id: 2,
      name: t('biz_process.standart_activity'),
    },
  ];

  return tabBOProcess;
}

export default TabList;
